import { useEffect, useRef } from "react";
import Lenis from "lenis";
import "lenis/dist/lenis.css";

import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/EditorialMarquee";
import Manifesto from "@/components/Manifesto";
import MenuSection from "@/components/MenuSection";
import DoveSiamo from "@/components/DoveSiamo";
import Contatti from "@/components/Contatti";
import WhatsAppFloat from "@/components/WhatsAppFloat";

const useLenis = () => {
    const rafRef = useRef();
    useEffect(() => {
        const lenis = new Lenis({
            duration: 1.15,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            smoothWheel: true,
            smoothTouch: false,
            wheelMultiplier: 1,
            touchMultiplier: 1.2,
        });
        const raf = (time) => {
            lenis.raf(time);
            rafRef.current = requestAnimationFrame(raf);
        };
        rafRef.current = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafRef.current);
            lenis.destroy();
        };
    }, []);
};

const Home = () => {
    useLenis();
    return (
        <div className="App grain">
            <Nav />
            <main>
                <Hero />
                <EditorialMarquee />
                <Manifesto />
                <EditorialMarquee inverted speed={22} />
                <MenuSection />
                <DoveSiamo />
                <Contatti />
            </main>
            <WhatsAppFloat />
        </div>
    );
};

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="*" element={<Home />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
